<template>
  <div id="app" :class="$route.name">
    <NavBar id="top" :class="popupOpened? 'blur': ''"/>
    <Home/>
    <Forecast :class="popupOpened? 'blur': ''"/>
    <Accumulation :class="popupOpened? 'blur': ''"/>
    <Popup :class="popupOpened? 'active': ''"
      :content="popupContent" :mode="popupMode"/>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import Popup from '@/components/Popup'

import Home from '@/views/Home.vue'
import Forecast from '@/views/Forecast.vue'
import Accumulation from '@/views/Accumulation.vue'


export default {
components: {
  NavBar,
  Popup,
  Home,
  Forecast,
  Accumulation,
},
data() {return {
  popupOpened: false,
  popupContent: '',
  popupMode: '',
  popupData: '',
  dimensions: require('./assets/json/dimension.json'),
  finTools: require('./assets/json/financial_tools.json'),
  subjStockpiling: require('./assets/json/subjects_of_stockpiling.json'),
  content: require('./assets/json/content.json'),
}},
watch: {
  $route(to, from) {
    document.querySelector('#top').scrollIntoView({block: "start", behavior: "smooth"})
    if (to.name === 'Home') {
      this.popupOpened = false
    }
  }
},
}
</script>

<style lang="scss">
  @import './assets/fonts/font.css';
  @import './assets/main.scss';

  :root, body {
    position: fixed;
    top: 0;
    left: 0;
    user-select: none;
    color: $text;
    font-family: 'Rubik', sans-serif;
    height: 100%;
    width: 100%;
    overflow: hidden;
  }
  
  #app {
    scroll-behavior: smooth;
    overflow: hidden;
    overflow-y: auto;
    width: 100%;
    height: 100vh;
    position: fixed;
    background: linear-gradient(80.66deg, #EFC7F2 0%, #F4CFCE 100%);
    background-attachment: fixed;
  }
  #app.Forecast {
    background: linear-gradient(181.45deg, #D8C8F5 0%, #FEDAE1 99.88%);
  }
  #app.Accumulation {
    background: linear-gradient(181.45deg, #F5D1CE 0%, #EEAECD 99.88%);
  }
</style>
